<template>
  <div
    v-if="activeSlider"
    class="rfp-rr-title-section-177-or review-popup-overlay"
    style="display: block; overflow: auto"
  >
    <div
      v-if="alreadySubmitedPopup"
      class="rfp-rr-already-submited-001-or review-popup full-review-active"
      data-popup="review-popup"
      style="display: block"
    >
      <div class="rfp-rr-already-submited-002-or review-popup-close" @click="closePopup">
        {{ popupClose }}
      </div>
      <div
        id="messageSuccess"
        class="rfp-rr-already-submited-003-or popup-inner"
        style="display: block"
      >
        <div
          class="rfp-rr-already-submited-004-or message-icon success"
          :class="{ 'image--display': alreadySubmitedIcon === '' }"
        >
          <img
            class="rfp-rr-already-submited-005-or"
            :src="alreadySubmitedIcon"
            :style="{ width: '100%' }"
            :alt="alreadySubmitedIconAltText"
          />
        </div>
        <div class="rfp-rr-already-submited-006-or message" v-html="alreadySubmitedText"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-ratings-already-submited',
  props: {
    alreadySubmitedIcon: {
      type: String,
      required: true,
    },
    alreadySubmitedText: {
      type: String,
      required: true,
    },
    alreadySubmitedIconAltText: {
      type: String,
      required: true,
    },
    popupClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      alreadySubmitedPopup: false,
      activeSlider: false,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('alreadySubmitedReview', () => {
      this.alreadySubmitedPopup = true;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.toggle('popup_scroll');
      eventBus.emit('ScrollFalse');
      document.body.classList.add('rare-custom-body-class');
      this.activeSlider = true;
    });
  },
  methods: {
    closePopup() {
      this.alreadySubmitedPopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody.classList.remove('popup_scroll');
      document.body.classList.remove('rare-custom-body-class');
      this.activeSlider = false;
      eventBus.emit('ScrollTrue');
    },
  },
};
</script>
